import React from 'react';
import './ContactSection.css';

const ContactSection = () => {
  return (
    <section className="contact section" id="discovery">
      <div className="container">
        <div className="contact-layout contact-layout-single">
          <div className="contact-info">
            <a href="/business-discovery/" className="discovery-owl" aria-label="Take the Free Digital Audit">
              <img src="/assets/mascot.png" alt="The Owleyes Owl" className="discovery-owl-img" />
            </a>
            <h2 className="contact-title">Free Digital Audit</h2>
            <p className="contact-subtitle">
              In 5&ndash;7 minutes, discover where your business is losing time, margin or
              visibility &mdash; and what to improve first. Receive a personalised opportunity snapshot before we speak.
            </p>
            <a href="/business-discovery/" className="btn btn-primary">
              Take the Free Digital Audit
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
